import styled from 'styled-components';
import MenuIconMDI from 'mdi-react/MenuIcon';
import { media, remCalc } from 'src/components/base';

type MenuButtonProps = {
  active?: boolean;
};

export const MenuButton = styled.button.attrs({ type: 'button' })<
  MenuButtonProps
>`
  color: ${props => props.theme.header.fg};
  line-height: inherit;
  text-align: left;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  display: flex;
  position: relative;

  ${media.largeUp`
    display: none;
  `};

  &.focus-visible {
    background: ${p => (p.active ? 'white' : p.theme.buttons.primary.bg)};
  }
`;

export const MenuIcon = styled(MenuIconMDI).attrs({ size: 32 })`
  min-width: ${remCalc(27)};
`;
